import { render, staticRenderFns } from "./KycApplicationViewCard.vue?vue&type=template&id=5ffafea7"
import script from "./KycApplicationViewCard.vue?vue&type=script&lang=js"
export * from "./KycApplicationViewCard.vue?vue&type=script&lang=js"
import style0 from "./KycApplicationViewCard.vue?vue&type=style&index=0&id=5ffafea7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports